export default IconPyramidPlus => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-pyramid-plus" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M18.719 11.985l-5.889 -9.539a.999 .999 0 0 0 -1.664 0l-8.54 13.836a1.005 1.005 0 0 0 .386 1.452l8.092 4.054a1.994 1.994 0 0 0 1.789 0l.149 -.074" />
  <path d="M12 2v20" />
  <path d="M16 19h6" />
  <path d="M19 16v6" />
</svg>`;